<template>
  <div>
    <common-list
      ref="list"
      url="Example/GetList"
      @currentrow="handlerCurrentRow"
    >
      <template v-slot:filter="{ filter }">
        <el-form-item label="姓名" prop="ExampleName">
          <el-input
            v-model.trim="filter.ExampleName"
            placeholder="姓名"
            clearable
          ></el-input>
        </el-form-item>
      </template>
      <template v-slot:option>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="add"
          v-if="auth('TableDemoAdd')"
          >添加</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-edit"
          @click="edit"
          v-if="auth('TableDemoEdit')"
          >编辑</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          @click="deleteItem"
          v-if="auth('TableDemoDelete')"
          >删除</el-button
        >
      </template>
      <template v-slot:body>
        <el-table-column
          label="姓名"
          prop="ExampleName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="密码"
          prop="ExamplePassword"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="权限列表"
          prop="Permission"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="是否在线" show-overflow-tooltip>
          <template v-slot="{ row }">
            <span>{{ row.IsOnline ? "在线" : "离线" }}</span>
          </template>
        </el-table-column>
      </template>
    </common-list>
    <add-edit
      ref="addedit"
      @success="getData"
      :item="aeitem"
      title="表格示例"
      getUrl="Example/GetOne"
      addUrl="Example/Add"
      editUrl="Example/Edit"
      width="500px"
    >
      <template v-slot="{ form }">
        <el-form-item
          label="姓名"
          prop="ExampleName"
          :rules="[$g.validRequired, $g.validLen(20)]"
        >
          <el-input
            v-model.trim="form.ExampleName"
            placeholder="姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          prop="ExamplePassword"
          :rules="[$g.validRequired, $g.validLen(25)]"
        >
          <el-input
            v-model.trim="form.ExamplePassword"
            placeholder="密码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="权限列表"
          prop="Permission"
          :rules="[$g.validRequired, $g.validLen(30)]"
        >
          <el-input
            v-model.trim="form.Permission"
            placeholder="权限列表"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="是否在线"
          prop="IsOnline"
          :rules="$g.validRequired"
        >
          <el-select v-model="form.IsOnline" style="width: 100%">
            <el-option label="是" :value="true"> </el-option>
            <el-option label="否" :value="false"> </el-option>
          </el-select>
        </el-form-item>
      </template>
    </add-edit>
  </div>
</template>

<script>
export default {
  data() {
    return {
      aeitem: {},
    };
  },
  mounted() {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    add() {
      this.$refs.addedit.type = "add";
      this.aeitem = {};
    },
    edit() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$refs.addedit.type = "edit";
      this.aeitem = { ExampleID: this.currentrow.ExampleID };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$confirm(
        `将删除姓名为【${this.currentrow.ExampleName}】的示例, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("Example/Delete", {
            ExampleID: this.currentrow.ExampleID,
          }).then(() => {
            this.$message.success("删除成功");
            this.$refs.list.getTableData();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
</style>